import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  Col,
} from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { getAthletes } from "store/actions/athletesAction";
import { Input } from "reactstrap/es";
import { searchFansOrAthletes } from "store/actions/athletesAction";
import SearchBar from "components/SearchBar";
import OnlyHeader from "components/Headers/OnlyHeader";
import moment from "moment";
import { toast } from "react-toastify";
import pizzaModule from "../assets/img/custom/pizzaModule.jpg";
const SchoolAthletes = () => {
  const csvLink = useRef(null);
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const {
    schoolAthletes,
    isLoading,
    loadmoreLoader,
    athletesLastDocument,
    athletesMoreDocuments,
  } = useSelector((state) => state.athletes);

  const [selectedRows, setSelectedRows] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleCheckboxChange = (item) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.some((row) => row.id === item.id)) {
        return prevSelectedRows.filter((row) => row.id !== item.id);
      } else {
        return [...prevSelectedRows, item];
      }
    });
  };

  const handleLoadMore = () => {
    if (user?.state && user?.country && user?.school && athletesLastDocument) {
      dispatch(
        getAthletes({
          state: user?.state,
          city: user?.country,
          school: user?.school,
          lastDocument: athletesLastDocument,
          prevData: schoolAthletes,
        })
      );
    }
  };
  const areAllFieldsFilled = () => {
    return selectedRows.every((row) => row.ENDING_DATE);
  };

  const handleCSVDownload = (e) => {
    if (!areAllFieldsFilled()) {
      e.preventDefault();
      toast.error("All fields are required");
    } else {
      toggleModal();
      setTimeout(() => {
        setSelectedRows([]);
      }, 2000);
    }
  };

  const handleInput = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setSearchId(value);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const trimmedValue = searchId.trim();
    let payload = {
      id: Number(searchId),
      role: "athlete",
      state: user?.state,
      city: user?.county,
      school: user?.instituteName,
    };
    if (trimmedValue && user?.state && user?.county && user?.instituteName) {
      setSearchLoader(true);
      await dispatch(
        searchFansOrAthletes(payload, (data) => {
          setSearchData(data);
          setSearchId("");
          setSearchLoader(false);
        })
      );
    }
    setSearchLoader(false);
  };
  const handleInputChange = (id, field, value) => {
    const regex = /^[0-9]*$/;
    if (field !== "ENDING_DATE" && !regex.test(value)) {
      return;
    }
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  useEffect(() => {
    if (user?.state && user?.county && user?.instituteName) {
      dispatch(
        getAthletes({
          state: user?.state,
          city: user?.county,
          school: user?.instituteName,
          lastDocument: null,
          prevData: [],
        })
      );
    }
  }, []);

  return (
    <>
      <OnlyHeader />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col lg="12">
            <img src={pizzaModule} alt="" width="100%" className="mb-5" />
          </Col>
        </Row>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 ">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h3 className="mb-0 whitespace-nowrap">Hm Pg Buttons</h3>
                  <div className="d-flex justify-content-end align-items-center">
                    {!isLoading && user && (
                      <>
                        <Button
                          onClick={toggleModal}
                          color="primary"
                          disabled={selectedRows.length === 0}
                          className="whitespace-nowrap responsive-button"
                        >
                          Export CSV
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <SearchBar
                  searchId={searchId}
                  handleInput={handleInput}
                  handleSearch={handleSearch}
                  searchLoader={searchLoader}
                />
              </CardHeader>
              {isLoading && user ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <Table
                    className="align-items-center table-flush mb-3"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Select</th>
                        <th scope="col">ID</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchData.length > 0 ? (
                        searchData.map((item) => (
                          <tr key={item?.id}>
                            <td className="d-flex">
                              <Input
                                className="mx-2 position-relative"
                                type="checkbox"
                                checked={selectedRows.some(
                                  (row) => row.id === item.id
                                )}
                                onChange={() => handleCheckboxChange(item)}
                              />
                            </td>
                            <td>{item?.athleteID}</td>
                            <td>{item?.first_name + " " + item?.last_name}</td>
                            <td>{item?.email}</td>
                          </tr>
                        ))
                      ) : schoolAthletes.length > 0 ? (
                        schoolAthletes?.map((item) => {
                          return (
                            <tr key={item?.id}>
                              <td className=" d-flex">
                                <Input
                                  className="mx-2 position-relative"
                                  type="checkbox"
                                  checked={selectedRows.some(
                                    (row) => row.id === item.id
                                  )}
                                  onChange={() => handleCheckboxChange(item)}
                                />
                              </td>
                              <td>{item?.athleteID}</td>
                              <td>
                                {item?.first_name + " " + item?.last_name}
                              </td>
                              <td>{item?.email}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {athletesMoreDocuments && searchData.length === 0 && (
                    <div className="w-100 d-flex justify-content-center my-3">
                      {" "}
                      <Button
                        color="primary"
                        size="sm"
                        disabled={!athletesMoreDocuments}
                        onClick={handleLoadMore}
                      >
                        {loadmoreLoader ? <Spinner size="sm" /> : "LoadMore"}
                      </Button>
                    </div>
                  )}
                  {searchData.length > 0 && (
                    <div className="w-100 d-flex justify-content-center my-3">
                      {" "}
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          setSearchData([]);
                          setSearchId("");
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  )}
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={toggleModal} size="md">
        <ModalBody>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">FHP Id</th>
                <th scope="col">Ending Date</th>
              </tr>
            </thead>
            <tbody>
              {selectedRows.length > 0 ? (
                selectedRows?.map((item) => {
                  return (
                    <tr key={item?.id}>
                      <td>{item?.athleteID}</td>
                      <td>
                        <Input
                          name="ENDING_DATE"
                          value={item?.ENDING_DATE || ""}
                          type="date"
                          style={{ width: "180px" }}
                          min={moment().format("YYYY-MM-DD")}
                          onChange={(e) =>
                            handleInputChange(
                              item.id,
                              "ENDING_DATE",
                              e.target.value
                            )
                          }
                          required
                        />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>N/A</td>
                  <td>N/A</td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <CSVLink
            ref={csvLink}
            headers={[
              { label: "FHP_ID", key: "FHP_ID" },
              { label: "ENDING_DATE", key: "ENDING_DATE" },
            ]}
            filename={`athlete.csv`}
            data={
              selectedRows == -1
                ? []
                : selectedRows.map((item) => {
                    return {
                      ...item,
                      FHP_ID: item?.athleteID,
                      ENDING_DATE: moment(item?.ENDING_DATE).format(
                        "MM/DD/YYYY"
                      ),
                    };
                  })
            }
            className={`ml-auto btn btn-primary text-nowrap ${
              selectedRows.length === 0 ? "disabled" : ""
            }`}
            onClick={handleCSVDownload}
          >
            Export
          </CSVLink>
          <Button onClick={toggleModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SchoolAthletes;
